<template>
<div class="results">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
            <van-sticky :offset-top="offsetTop">
                <div class="total" @click="scCilck()">
                    <span></span>
                    <AuctionFilter ref="filter-com" @search="search" :type="3" />
                </div>
            </van-sticky>
            <template v-if="loading && !list.length">
                <div class="item" v-for="n in 6" :key="'loading-' + n">
                    <div class="item-info">
                        <van-skeleton class="vs-info" title :row="3" />
                    </div>
                    <div class="item-content">
                        <van-skeleton class="vs-img" :row="1" />
                    </div>
                </div>
            </template>
            <div class="item" @click="toDetail(item,index)" v-for="(item,index) in list" :key="item.source_code">
                <div class="item-info">
                    <div class="top">
                        <div class="top-item">{{ item.name }}</div>
                        <div class="top-item">{{ item.organ_name }} {{ item.city }}</div>
                    </div>
                    <div class="info-items">
                        <div class="info-item">
                            <div class="label">拍卖时间：</div>
                            <div class="value">{{ item.auction_date }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">拍品总数：</div>
                            <div class="value">{{ item.total }}</div>
                        </div>
                        <div class="info-item" v-if="item.total_price">
                            <div class="label">成交额：</div>
                            <div class="value">RMB <span>{{ item.total_price }}</span> 万</div>
                        </div>
                    </div>
                </div>
                <div class="item-img">
                    <div class="img">
                        <van-image class="bg" :src="item.cover_pic" />
                        <van-image class="poster" :src="item.cover_pic" />
                        <div class="tag" v-if="item.online_auction === 1">{{ item.online_auction_text }}</div>
                    </div>
                    <div class="level" v-if="item.type === 2"></div>
                </div>
            </div>

            <EmptyPage v-if="page === 1 && !list.length && !loading" />

            <template #finished v-if="list.length">
                <div class="noMore">
                    <span>我是有底线的</span>
                </div>
            </template>
        </van-list>
    </van-pull-refresh>
</div>
</template>

<script>
import AuctionFilter from '@/views/previewNew/component/AuctionFilter.vue'
import barMixin from '@/views/previewNew/component/bar-mixin'
import EmptyPage from '@/components/empty/emptyPage.vue'
import {
    getAuctionList
} from '@/api/preview'
import {
    getWXConfig
} from '@/assets/js/weixinShare'
import {
    scMdFunc
} from '@/assets/js/scData'
export default {
    name: 'results',
    components: {
        EmptyPage,
        AuctionFilter
    },
    mixins: [barMixin],
    data() {
        return {
            list: [],
            shareMessage: {},
            loading: false,
            finished: false,
            refreshing: false,
            page: 1,
            total: '加载中',
            params: {},

            ads: {}
        }
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        scCilck() {
            scMdFunc('allClick', {
                cur_page: '21',
                cur_moudle: '21-0',
                cur_button: '21-0-1',
            })
        },
        onLoad() {
            getAuctionList({
                special_type: 3,
                page: this.page,
                ...this.params
            }).then(res => {
                if (res.code === 0) {
                    if (this.refreshing) {
                        this.list = []
                        this.refreshing = false
                    }
                    res.data.list.forEach((item => {
                        if (item.isAD) {
                            this.ads[item.source_code] = true
                        }
                    }))
                    this.list.push(...res.data.list.filter(i => i.isAD || (!i.isAD && !this.ads[i.source_code])))
                    this.total = res.data.special_total

                    this.loading = false
                    this.shareMessage = res.data.shareMessage
                    this.setWxConfig();
                    this.page++

                    if (!res.data.morePage) {
                        this.finished = true
                    }
                }
            })
        },
        onRefresh() {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
            this.page = 1
            this.finished = false
            this.loading = true
            this.onLoad()
        },
        setWxConfig() {
            if (this.shareMessage) {
                document.title = this.shareMessage.title;
                window.AFedWxShareData = {
                    title: this.shareMessage.title,
                    imgUrl: this.shareMessage.pic || 'https://pubunder.artron.net/pubimgs/m/wxImgAuc.png',
                    desc: this.shareMessage.desc || '',
                    link: this.shareMessage.url
                }
                getWXConfig(window.AFedWxShareData)
            }

        },
        search(params) {
            if (params) {
                this.params = params
            } else {
                this.params = {}
            }
            this.$refs['filter-com'].saveTemp()
            this.$router.push({
                name: 'previewSearchResult',
                params
            })
            // this.list = []
            // this.onRefresh()
        },
        toDetail(item,i) {
            if (item.type == 1) {

                scMdFunc('allClick', {
                    cur_page: '21',
                    cur_moudle: '21-1',
                    cur_button: '21-1-' + Number(i + 1),
                    auction_specia_performance_id_pk: item.special_id,
                    auction_specia_performance_id: item.special_code,
                    the_auction_id_pk: item.session_id,
                    the_auction_id: item.session_code,
                    auction_company_id: item.organ_id,
                    auction_company_code: item.organ_code,
                    auction_state: item.status == 1 ? '待拍卖' : item.status == 2 ? '预展中' : item.status == 3 ? '待预展' : item.status == 4 ? '拍卖中' : item.status == 5 ? '已结拍' : '',
                    auction_type: item.bid_type
                })
            } else {
                scMdFunc('allClick', {
                    cur_page: '21',
                    cur_moudle: '21-1',
                    cur_button: '21-1-' + Number(i + 1),
                    the_auction_id_pk: item.session_id,
                    the_auction_id: item.session_code,
                    auction_company_id: item.organ_id,
                    auction_company_code: item.organ_code,
                    auction_state: item.status == 1 ? '待拍卖' : item.status == 2 ? '预展中' : item.status == 3 ? '待预展' : item.status == 4 ? '拍卖中' : item.status == 5 ? '已结拍' : '',
                    auction_type: item.bid_type,
                })

            }
            if (item.type === 1) {
                this.$router.push({
                    name: 'search_special',
                    params: {
                        specialCode: item.source_code
                    }
                })
            } else {
                this.$router.push({
                    name: 'session',
                    params: {
                        sessionCode: item.source_code
                    }
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "common";

.results {
    .item {
        display: flex;
        align-items: center;
        padding: .8rem 0;

        .vs-info {
            padding: 0;

            .van-skeleton__title {
                width: 100%;
                height: 1rem;
                margin-bottom: .6rem;
            }

            .van-skeleton__row {
                margin-top: .3rem;
                height: .7rem;

                &:nth-child(2) {
                    width: 70% !important;
                }

                &:nth-child(3) {
                    width: 60% !important;
                }

                &:nth-child(4) {
                    width: 80% !important;
                }
            }
        }

        .vs-img {
            width: 5rem;
            height: 5rem;
            border-radius: 0.6rem;
            overflow: hidden;
            padding: 0;

            .van-skeleton__row {
                width: 100% !important;
                height: 100%;
            }
        }

        &-info {
            width: calc(100% - 6rem);
            margin-right: .6rem;

            .top {
                margin-bottom: .4rem;
                font-size: 0.7rem;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
                line-height: 0.82rem;
                width: 100%;

                .top-item {
                    width: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }

            .info-items {
                .info-item {
                    display: flex;
                    align-items: center;
                    font-size: 0.6rem;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #949596;
                    line-height: 0.7rem;
                    width: 100%;
                    &:not(:last-child) {
                        margin-bottom: .05rem;
                    }

                    .label {
                        width: 3.05rem;
                        margin-right: .3rem;
                        white-space: nowrap;
                    }

                    .value {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        span {
                            font-size: 0.8rem;
                            font-family: DINPro-Bold, DINPro;
                            font-weight: bold;
                            color: #000000;
                            line-height: 0.8rem;
                        }
                    }
                }
            }
        }

        &-img {
            width: 5.4rem;
            height: 5rem;

            .img {
                width: 5rem;
                height: 5rem;
                border-radius: 0.6rem;
                position: relative;
                overflow: hidden;
                z-index: 2;

                /deep/ .bg {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    transform: scale(1.2);

                    .van-image__img {
                        width: 100%;
                        height: 100%;
                        object-fit: fill;
                        -webkit-filter: blur(10px);
                        -moz-filter: blur(10px);
                        -ms-filter: blur(10px);
                        filter: blur(10px);
                    }
                }

                /deep/ .poster {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 2;

                    .van-image__img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                .tag {
                    width: 100%;
                    height: 1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.5rem;
                    font-family: DINPro-Medium, DINPro;
                    font-weight: 500;
                    color: #FFFFFF;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    z-index: 4;
                }
            }

            .level {
                width: 4.4rem;
                height: 4.4rem;
                background: rgba(169, 169, 169, 0.5);
                border-radius: 0.6rem;
                margin: -4.7rem 0 0 .8rem;
                position: relative;

                &::after {
                    display: block;
                    content: '';
                    width: 4.4rem;
                    height: 3.8rem;
                    background: rgba(169, 169, 169, 0.3);
                    border-radius: 0.6rem;
                    position: absolute;
                    left: .3rem;
                    top: .3rem;
                }
            }
        }
    }

    .noMore {
        margin-top: 1.2rem;
        text-align: center;
        font-size: 0.65rem;
        color: #cccccc;
        padding-bottom: 2rem;

        span {
            position: relative;
            display: inline-block;
            padding: 0 0.5rem;

            &::before,
            &::after {
                content: "";
                position: absolute;
                width: 2.5rem;
                height: 0.05rem;
                background: #dddee3;
                top: 50%;
                transform: translateY(-50%);
            }

            &::before {
                left: 100%;
            }

            &::after {
                right: 100%;
            }
        }
    }
}
</style>
